import { Link } from "react-router-dom";
import type { VideoItem } from "@/types/video";

interface VideoCardProps {
  item: VideoItem;
}

export default function VideoCard({ item }: VideoCardProps) {
  return (
    <Link
      to={`/detail/${item.id}`}
      className="group block overflow-hidden rounded-lg border border-background-200 bg-background-100 transition-colors duration-200 hover:border-primary-500/60"
      title={`${item.title} - ${item.type}在线观看推荐`}
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-200">
        <img
          src={item.cover}
          alt={`${item.title}封面`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-2 top-2 rounded-md bg-primary-500 px-1.5 py-0.5 font-label text-[11px] font-semibold text-background-50">
          {item.type}
        </span>
        <span className="absolute right-2 top-2 flex items-center gap-0.5 rounded-md bg-background-950/70 px-1.5 py-0.5 font-label text-[12px] font-bold text-primary-400">
          <i className="ri-star-fill text-[11px]"></i>
          {item.rating.toFixed(1)}
        </span>
        <div className="absolute inset-x-0 bottom-0 flex items-center justify-between bg-gradient-to-t from-background-950/90 to-transparent px-2 pb-1.5 pt-6">
          <span className="truncate text-[11px] font-medium text-foreground-800">{item.status}</span>
        </div>
      </div>
      <div className="px-2.5 py-2.5">
        <h3 className="truncate text-sm font-semibold text-foreground-950 transition-colors group-hover:text-primary-400">
          {item.title}
        </h3>
        <p className="mt-1 truncate text-xs text-foreground-500">
          {item.year} · {item.region} · {item.tags.slice(0, 2).join(" ")}
        </p>
      </div>
    </Link>
  );
}